import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";

import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { mapMany } from "keautils";
import { Cotizacion, CotizacionConcepto, CotizacionGrupo } from "./logic";

/*
La vista de cotización es una tabla con la siguiente forma

|  Titulo grupo                           |
|  Cantidad  | Titulo   |  $  | Importe   |
|        Titulo         |  $  |           | 
|  Titulo grupo                           |
|  Cantidad  | Titulo   |  $  | Importe   |
|        Titulo         |  $  | Importe   | 
| TOTAL                 |  $  | Importe   |
*/

export interface Props {
    value: Cotizacion;
}

class Importe extends React.PureComponent<{ value: number }> {
    render() {
        return [
            <td key="1" style={{ textAlign: "right", fontFamily: "monospace" }} >$</td>,
            <td key="2" style={{ textAlign: "right", fontFamily: "monospace" }} >{kea.formatDecimal(this.props.value)}</td>
        ];
    }
}

class FilaTitulo extends React.PureComponent<{ titulo: string }> {
    render() {
        return (
            <tr className="info" >
                <td colSpan={4}>
                    <label>{this.props.titulo}</label>
                </td>
            </tr>
        )
    }
}

class FilaItem extends React.PureComponent<{ value: CotizacionConcepto }> {
    render() {
        const x = this.props.value;
        const verCantidad = x.cantidad != null;
        return (
            <tr>
                {verCantidad && <td>{x.cantidad}</td>}
                <td colSpan={verCantidad ? 1 : 2} >{x.titulo}</td>
                <Importe value={x.importe} />
            </tr>
        )
    }
}

class FilasGrupo extends React.PureComponent<{ value: CotizacionGrupo }> {
    render() {
        const x = this.props.value;
        return [
            <FilaTitulo key="titulO" titulo={x.titulo} />,
            ...x.conceptos.map((x, i) => <FilaItem key={i} value={x} />)
        ];
    }
}

class FilaTotal extends React.PureComponent<{ value: number, label: string, estilo?: "total" | "descuento" }> {
    render() {
        const estilo = this.props.estilo;
        return (
            <tr key="total" className={estilo == "descuento" ? "success" : estilo == "total" ? "warning" : ""} >
                <td colSpan={2}>
                    {this.props.label}
                </td>
                <Importe value={this.props.value} />
            </tr>
        );
    }
}

class FilasSubtotal extends React.PureComponent<{ value: Cotizacion }> {
    render() {
        const x = this.props.value;
        const flete = <FilaTotal key="flete" value={x.flete} label="Flete" />;
        const subtot = <FilaTotal key="subtot" value={x.subtotal} label="Subtotal" />;
        if(x.descuentoFlete > 0 ) {
            return [
                <FilaTotal key="descflet" value={x.descuentoFlete} label="Descuento flete" estilo="descuento" />, 
                flete,
                subtot
            ];
        } else {
            return [
                flete,
                subtot
            ];
        }
    }
}

class FilasTotales extends React.PureComponent<{ value: Cotizacion }> {
    render() {
        const x = this.props.value;
        return [
            <FilaTitulo key="titulo" titulo="Totales" />,
            <FilasSubtotal key="subtotal" value={x} />,
            <FilaTotal key="iva" value={x.iva} label="Iva" />,
            x.retencionIva > 0 && <FilaTotal key="riva" value={x.retencionIva} label="Retención de IVA" />,
            <FilaTotal key="total" value={x.total} label="Total" estilo="total" />
        ];
    }
}

class FilasCotizacion extends React.PureComponent<{ value: Cotizacion }> {
    render() {
        console.log("<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<<");
        console.log(this);
        
        const x = this.props.value;
        return [
            ...x.grupos.map((x, i) => <FilasGrupo key={i} value={x} />),
            <FilasTotales key="totales" value={x} />
        ];
    }
}


export class CotizacionView extends React.PureComponent<Props> {
    render() {
        return (
            <table className="table table-sm">
                <tbody>
                    <FilasCotizacion value={this.props.value} />
                </tbody>
            </table>
        );
    }
}


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/guias/documentacion/componentes/guias/cotizacionview.tsx